import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaInfoCircle } from "react-icons/fa";

import { calculatePercentage } from "@/utils/calculatePercentage";
import { getIndicatorClassificationColorClassName, IndicatorEsfEnum } from "@/utils/indicatorsEsf";
import { ResumeIndicatorC3Data } from "@/services/esus/indicator/esf/c3/getResumeIndicatorC3";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type IndicatorEsfC3ResumeProps = {
	resume: ResumeIndicatorC3Data;
};

export function IndicatorEsfC3Resume({ resume }: Readonly<IndicatorEsfC3ResumeProps>) {
	const puerperalsIndicatorPercentage = calculatePercentage(
		resume.totalPuerperalsScore,
		resume.maxPuerperalsScore
	);

	return (
		<Row className="mx-0">
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Gestantes e puérperas"
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={resume.totalPregnantsAndPuerperals.toLocaleString()}
					metaData={
						<CardOverlayTrigger
							header="Gestantes e puérperas"
							message="Quantidade de gestantes e puerperas identificadas no período informado"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Puérperas"
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={resume.totalPuerperals.toLocaleString()}
					metaData={
						<CardOverlayTrigger
							header="Puérperas"
							message="Quantidade de puérperas com período puerperal finalizado no período informado"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="Pontuação"
					value={resume.totalPuerperalsScore.toLocaleString()}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header="Pontuação"
							message="Quantidade de pontos alcançados nas práticas realizadas no indicador(somatório de pontos de todos os cidadãos)"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={6} lg={3} xl={3} className="mb-2">
				<CardInformative
					title="% Classificação"
					value={`${puerperalsIndicatorPercentage}%`}
					classNameCard="border border-muted rounded p-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue={`text-${getIndicatorClassificationColorClassName(
						IndicatorEsfEnum.C3,
						puerperalsIndicatorPercentage
					)}`}
					metaData={
						<CardOverlayTrigger
							header="% Classificação"
							message="Percentual de pontos alcançados em relação a pontuação máxima do indicador"
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
		</Row>
	);
}
